var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 4.2C14.5 5.8 15.5 7 16.9 7.6C17.4 7.8 18 7.9 18.6 7.9V10.1C17.4 10.1 16.3 9.8 15.3 9.2V14.9C15.3 17.5 13.1 19.6 10.5 19.6C7.9 19.6 5.8 17.5 5.8 14.9C5.8 12.2 7.9 10.1 10.5 10.1C10.8 10.1 11.2 10.2 11.5 10.2V12.5C11.2 12.3 10.8 12.2 10.5 12.2C9.1 12.2 7.9 13.4 7.9 14.9C7.9 16.3 9.1 17.5 10.5 17.5C12 17.5 13.2 16.3 13.2 14.9V4.2H14.2Z",
    fill: "#E0DAD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.bc3c973138cdf04a9f7cca24497b39f9.svg";
export { ForwardRef as ReactComponent };